const { createApp, ref,reactive,toRefs,onBeforeMount,onMounted,computed,watch } = Vue
function money(value) {
    if(!value || value == '')
      return "-"
    const formatter = new Intl.NumberFormat('ja-JP', {  })
    let price = parseInt(value) / 100 
    
    return  formatter.format(price) 
}

function mergeSimilarStrings(string1, string2) {
  let result = "";
  
  for (let char of string1) {
      if (string2.includes(char)) {
          result += char;
      }
  }

  return result;
}
  
createApp({
    delimiters: ['${',"}"],
    setup() {

        const state = reactive({
            bundle: [],
            variant: computed(getVariant),
            selected:  computed(getSelection),
            buyButton: computed(checkBuy)
        })
          
        // COMPUTED
        function getSelection(){
          return state.bundle.map( product => {
            return product.variants.find( v=> product.selected == v.sku)
          })
        }

        function checkBuy(){
          if(!state.variant) return true;
          //let unavailable = state.selected.filter(s => !s.available)
          
          if(state.variant.available)
            return false

          return true
        }

        function getVariant(){
          let options = { } 
          shopifyProduct.options.forEach( option => {
            state.bundle.find( p => {
              if(option.name.includes(p.title)) {
                let optionvalue = option.values.find(op => {
        
                  if(p.name.includes('/') && p.name.includes(op))
                    return op;
                  else {
                    if( p.name == op ) {
                      return op;
                    }
                  }

                })
              
            

                if(!optionvalue)
                  p.available = false

                return options["option" + option.position] = optionvalue;
            
              }
            })
          });


   
        

          let asd = shopifyProduct.variants
            .find( v => {
              if(v.option1 == options.option1 &&
                v.option2 == options.option2 &&
                v.option3 == options.option3 )
                return v
            })

            

            if(asd)
              return asd;

            if(shopifyProduct.has_only_default_variant)
              return shopifyProduct.variants[0];
        }

        function changeSku(v,p) {
          p.featured_image = v.featured_image
          p.selected = v.sku
          p.name = v.name
          p.option1 = v.option1
          p.option2 = v.option2
          p.option3 = v.option3
          p.available = v.available

        }
    
        function getPrice(product){
       
          let variant = product.variants.find(v=> product.name == v.name)

          if(variant)
          return money(variant.price )
        }

        watch(()=>state.bundle, ()=> {
        }, { deep:true })


        onBeforeMount(  ()=> {
            // SET CURRENT PRODUCT VARIANT
            const url = new URL(window.location);
            let currentID = url.searchParams.get('variant')
            


           let vv = shopifyProduct.bundle.map(product=> {
              let variants = product.variants.filter(variant => {
                //if(!variant.available) return; 
                // CHECK IF OPTION 
                let optionInside = false;

                shopifyProduct.options.forEach(option => {
                    if(option.name.includes(variant.title)){
                      let ss = option.values.find(o=> {
                        if(variant.options.includes(o)) {
                          return o;
                        }
                      })

                      if(ss)
                        optionInside = true
                    }
                })  
              
      
                if(optionInside) {
                  variant.disabled = false
                  return variant;
                }else {
                  variant.disabled = true
                  return variant;
                }

              })             
          
              product.variants = variants 
              return product

           })

           console.log(vv)
            
           state.bundle = vv
       
          })



      return {
        ...toRefs(state),

        getPrice,
        changeSku,
        //FILTER
        money,
      }
    }

}).mount('main')
